import { render, staticRenderFns } from "./OrderAHItemEdit.vue?vue&type=template&id=60e35882&scoped=true"
import script from "./OrderAHItemEdit.vue?vue&type=script&lang=js"
export * from "./OrderAHItemEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderAHItemEdit.vue?vue&type=style&index=0&id=60e35882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e35882",
  null
  
)

export default component.exports